import { antiForgeryPost } from '../../../utils/fetch';

function post(url, data) {
    return antiForgeryPost(url, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
    });
}

function removeByWishListId(wishListItemId) {
    return post('/Wishlist/RemoveWishListItem', { wishListItemId });
}

export function list() {
    return fetch('/api/wishlist/getwishlistitems')
        .then(response => response.json())
        .then(response => response.Content);
}

export function add(productclassId) {
    return post('/product/addtowishlist', { productclassId });
}

export function remove(productclassId) {
    return new Promise((res) => {
        list()
            .then(items => {
                const match = items.find(item => item.ProductClassId === productclassId);

                if (match && match.WishListItemId) {
                    res(removeByWishListId(match.WishListItemId));
                }
            });
    });
}

